import React, { useState, useRef } from "react";
import jwtDecode from "jwt-decode";

import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import env from "@beam-australia/react-env";
import { useAtom } from "jotai";

import { loadingState } from "../../../states/loadingState";

import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import useApi from "../../../hooks/useApi";
import "./login.css";
import { Toast } from "primereact/toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

const Login = ({ settings }) => {
  const { t } = useTranslation();

  const api = useApi();

  const [isLoading, setIsLoading] = useAtom(loadingState);

  const navigate = useNavigate();

  const toast = useRef(null);

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      nick: "",
      password: "",
    },
  });

  const onSubmit = async (data) => {
    setIsLoading(true);

    try {
      console.log(`${env("API_URL")}/base/auth/web`);
      const response = await api.post(`${env("API_URL")}/base/auth/web`, data);

      localStorage.setItem("accessToken", response.data.accessToken.token);
      localStorage.setItem("refreshToken", response.data.refreshToken);

      const decodedToken = response.data.accessToken.token
        ? jwtDecode(response.data.accessToken.token)
        : null;
      console.log(decodedToken);
      localStorage.setItem("userId", decodedToken.userId);
      localStorage.setItem("userId", decodedToken.userId);
      localStorage.setItem("userId", decodedToken.userId);
      localStorage.setItem("clientId", decodedToken.clientId);
      localStorage.setItem("clientName", decodedToken.clientName);
      localStorage.setItem("userRole", decodedToken.userRole); 
      localStorage.setItem("personName",    decodedToken.personName);
  
      localStorage.setItem("hasOpenCredits", 
        
          response.data.accessToken.additionalInfo.hasOpenCredits.toLowerCase()
        
      );

      // localStorage.setItem("hasOpenCredits", 
      //   JSON.stringify(response.data.accessToken.additionalInfo.hasOpenCredits).toLowerCase());
      //localStorage.setItem("hasOpenCredits", true);

      console.log(response.data.accessToken) 
 
      navigate("/calculator");
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: t("errors.login"),
        life: 3000,
      });

      setIsLoading(false);
    }
  };

  const getFormErrorMessage = (error) => {
    return error && <small className="p-error">{error.message}</small>;
  };

  return (
    <React.Fragment>
      <Toast ref={toast} />
      <div className="container">
        <div className="flex justify-content-center p-4">
          <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
            <div className="field">
              <Controller
                name="nick"
                control={control}
                rules={{
                  required: t("forms.validation.required", {
                    entity: t("entities.administrators.nick"),
                  }),
                  maxLength: {
                    value: 30,
                    message: t("forms.validation.maxLength", {
                      entity: t("entities.administrators.nick"),
                      maxLength: 30,
                    }),
                  },
                }}
                render={({ field, fieldState }) => (
                  <React.Fragment>
                    <div className="flex justify-content-between">
                      <label htmlFor="nick">
                        {t("entities.administrators.nick")}
                      </label>
                      <div>{getFormErrorMessage(errors.nick)}</div>
                    </div>
                    <div className="form-crud">
                      <div className="p-inputgroup">
                        <span className="p-inputgroup-addon">
                          <i className="pi pi-user"></i>
                        </span>
                        <span className="p-float-label">
                          <InputText
                            id="nick"
                            {...field}
                            value={field.value || ""}
                            maxLength={30}
                            className={[
                              "form-control",
                              classNames({
                                "p-invalid": fieldState.invalid,
                              }),
                            ]}
                          />
                        </span>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              />
              <span className="inputHelpText inputHelpText_small">
                <FontAwesomeIcon
                  icon={faCircleInfo}
                  style={{ paddingRight: "5px" }}
                />
                Ingresá tu cédula sin puntos ni guiones.
              </span>
            </div>

            <div className="field">
              <Controller
                name="password"
                control={control}
                rules={{
                  required: t("forms.validation.required", {
                    entity: t("entities.administrators.password"),
                  }),
                  maxLength: {
                    value: 30,
                    message: t("forms.validation.maxLength", {
                      entity: t("entities.administrators.password"),
                      maxLength: 30,
                    }),
                  },
                }}
                render={({ field, fieldState }) => (
                  <React.Fragment>
                    <div className="flex justify-content-between">
                      <label htmlFor="password">
                        {t("entities.administrators.password")}
                      </label>
                      <div>{getFormErrorMessage(errors.password)}</div>
                    </div>
                    <div className="form-crud">
                      <div className="p-inputgroup">
                        <span className="p-inputgroup-addon">
                          <i className="pi pi-key"></i>
                        </span>
                        <span className="p-float-label">
                          <Password
                            toggleMask
                            id="password"
                            {...field}
                            inputRef={field.ref}
                            className={classNames({
                              "p-invalid": fieldState.error,
                            })}
                            feedback={false}
                          />
                        </span>
                      </div>
                    </div>
                  </React.Fragment>
                )}
              />
            </div>

            <div className="flex flex-row justify-content-start">
              <Button
                link
                label="Olvidé mi contraseña"
                loading={isLoading}
                style={{
                  textAlign: "left",
                  paddingLeft: "0",
                  marginBottom: "20px",
                }}
                onClick={() => navigate("/ResetPasswordStep1_initRecovery")}
              />
            </div>

            <Button
              label={t("Login")}
              icon="pi-sign-in pi "
              className="button_big"
              loading={isLoading}
            />

            <p
              className="inputHelpText inputHelpText_small"
              style={{ textAlign: "center", paddingTop: "20px" }}
            >
              Textum es un servicio exclusivo para el personal de nuestras
              empresas asociadas.
            </p>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Login;
